import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-customer-overview-form',
  imports: [RmsModule],
  templateUrl: './customer-overview-form.component.html',
  styleUrl: './customer-overview-form.component.scss'
})
export class CustomerOverviewFormComponent {
  Customer: any = {};

  // Net Cash vs. Docs (1) and Net Cash upon release (2) are cash-based terms -
  // no credit is being extended, so Credit Limit doesn't apply. Kept in sync
  // with the same rule in customer-payment-preferences.component.ts since both
  // screens write to the shared customer.CreditLimit column.
  private readonly CASH_TERM_IDS = [1, 2];

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef) {
    this.Customer = { ...data };
    if (this.isCashTerm) {
      this.Customer.CreditLimit = null;
    }
  }

  get isCashTerm(): boolean {
    return this.CASH_TERM_IDS.includes(this.Customer.PaymentTermId);
  }

  save() {
    if (this.isCashTerm) {
      this.Customer.CreditLimit = null;
    }
    this.ref.close({ ...this.Customer, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
